// extracted by mini-css-extract-plugin
export var content = "_v6-1";
export var wrapper = "_v6-0";